import browser from './browser/browser'
import chatContent from './chatContent/chatContent'

export default [
    browser,
    chatContent
]